import React, { createContext, useContext, useState } from "react";

const EarlyAccessContext = createContext();

export const EarlyAccessProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <EarlyAccessContext.Provider value={{ open, setOpen }}>
      {children}
    </EarlyAccessContext.Provider>
  );
};

export const useEarlyAccess = () => useContext(EarlyAccessContext);
